<template>
  <div>
    <div class="PcDevice_block">
      <div class="d-flex align-items-center mb-4">
        <img
          src="../assets/images/user.svg"
          class="mr-3"
          style="width: 50px; height: 50px"
          alt=""
        />
        <div>
          <h4>এখনই আমাদের সঙ্গে যোগ দিন</h4>
          <h6>বিশেষ সুবিধা উপভোগ করুন!</h6>
        </div>
      </div>
      <p>
        সর্বশেষ প্রদর্শনী আপডেট পান, টিকিট রিডিম ইভেন্টে অংশ নিন, বিশেষ সদস্য
        ছাড় উপভোগ করুন এবং আমাদের নিউজলেটার ও প্রদর্শনী নিউজলেটার বিনামূল্যে
        সাবস্ক্রাইব করুন।
      </p>

      <a
        href="https://www.chanchao.com.tw/accounts/bd/signup"
        class="btn btn-block btn-secondary mt-3"
        >সাইন আপ করুন</a
      >

      <hr />
    </div>

    <h4 class="my-4">FAQ</h4>

    <ul class="ml-0 pl-4">
      <li>
        <a
          href="https://www.chanchao.com.tw/downloads/%E6%9C%83%E5%93%A1%E8%A8%BB%E5%86%8A%E7%AF%87_En.pdf"
          target="_blank"
          >কিভাবে সদস্য হবেন??</a
        >
      </li>
      <li>
        <a
          href="https://www.chanchao.com.tw/downloads/%E9%82%80%E8%AB%8B%E4%BB%A3%E7%A2%BC%E7%B4%A2%E7%A5%A8_En.pdf"
          target="_blank"
          >টিকিট কিভাবে রিডিম করবেন?</a
        >
      </li>
      <li>
        <a
          href="https://www.chanchao.com.tw/downloads/%E5%BF%AB%E9%80%9F%E5%85%A5%E5%A0%B4%E7%AF%87(%E6%89%8B%E6%A9%9F%E7%89%88)_En.pdf"
          target="_blank"
          >দ্রুত প্রবেশ করবেন কীভাবে?</a
        >
      </li>
    </ul>

    <div class="d-flex mt-3">
      <a href="//www.chanchao.com.tw/en/qa.asp" target="_blank"
        >আরও জানুন<i class="fas fa-external-link-alt ml-2"></i
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {},

  created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
